import { gql } from "@apollo/client";

export const DELETE_CICD_PROJECTS = gql`
  mutation DeleteCicdProjects($input: DeleteProjectsInput!) {
    deleteCicdProjects(input: $input) {
      mrns
    }
  }
`;
